<script>
	/*
		TCareFieldPair.svelte

		Renders a label and an input field.

		const userInfoObject = {
			firstName: null,
			lastName: null,
			address1: null,
			address2: null,
			county: null,
			state: null,
			city: null,
			postalCode: null,
			country: null,
			phoneNumber: null,
			email: null
		}

	*/

	import TCareInput from "./TCareInput.svelte";

	export let source;
	export let prop;
	export let setValue;
	export let label;
	export let isRequired;

</script>

<style>

	.tcui-control.field-pair {
		margin-bottom: 10px;
		/* border: 1px solid green; */
	}

	.tcui-control.field-pair span {
		color: var(--tcui-secondary);
	}

	.tcui-control.field-pair .label {
		width: 20%;
		color: var(--tcui-field-label);
		font-size: 11px;
	}

	.tcui-control.field-pair .input {
		width: 80%;
	}

    .tcui-control.field-pair .is-required {
        /* font-weight: 800; */
        color: var(--tcui-secondary);
    }



</style>

<!-- must intercept setValue because it is an object structure -->
<!-- setFieldValue will be called every keyup -->


<div class="tcui-control flex-row field-pair">
	<div class="flex-row">
		<div class="label">
			{#if isRequired}
				<span class="is-required">{label}&nbsp;*</span>
			{:else}
				{label}
			{/if}
		</div>
		<div class="input">
			<TCareInput {source} {prop} {setValue} placeholder={''} />
		</div>
	</div>
</div>

